// Global
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem } from '@/components';

// Models
import { ICategory } from '@/models/categories.model';
import { StyledSelectDescription, StyledTreeSelect } from './ParentCategorySelectStyles';

// Helpers
import { TreeSelectDataNode, highlightText, filterTreeNode } from '@/modules/SharedCategories/helpers';

type TParentCategorySelect = {
  categories: ICategory[] | null;
  formItemName: string;
};

const ParentCategorySelect = ({ categories, formItemName }: TParentCategorySelect) => {
  const { t } = useTranslation(['categories']);

  const [searchValue, setSearchValue] = useState<string>('');

  const onSearch = (value: string) => {
    setSearchValue(value);
  };

  const treeData = useMemo(() => {
    return categories?.map((category) => ({
      value: category.id,
      title: category.name,
      children: category.sub_categories?.map((subCategory) => ({
        value: subCategory.id,
        title: subCategory.name,
      })),
    }));
  }, [categories]);

  const titleRender = (node: TreeSelectDataNode) => {
    return highlightText(node.title?.toString() || '', searchValue);
  };

  return (
    <div>
      <FormItem name={formItemName} label={t('parent_category')}>
        <StyledTreeSelect
          showSearch
          onSearch={onSearch}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          allowClear
          treeDefaultExpandAll
          treeData={treeData}
          filterTreeNode={filterTreeNode}
          treeTitleRender={titleRender}
        />
      </FormItem>
      <StyledSelectDescription>{t('parent_category_info')}</StyledSelectDescription>
    </div>
  );
};

export default ParentCategorySelect;
